function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#CBCBCB"
}, React.createElement("path", {
  d: "M12.167 10.6H3.833c-.46 0-.833.626-.833 1.4 0 .774.372 1.4.833 1.4h8.334c.46 0 .833-.626.833-1.4 0-.774-.373-1.4-.833-1.4zm-7.75-2.8h14.166C19.367 7.8 20 7.174 20 6.4c0-.774-.633-1.4-1.417-1.4H4.417C3.633 5 3 5.626 3 6.4c0 .774.633 1.4 1.417 1.4zm6.375 8.4H3.708c-.391 0-.708.626-.708 1.4 0 .774.317 1.4.708 1.4h7.084c.391 0 .708-.626.708-1.4 0-.774-.317-1.4-.708-1.4zM18.833 16.875h-1.666c-2.302 0-4.167 1.539-4.167 3.438 0 .38.373.687.833.687h8.334c.46 0 .833-.307.833-.688 0-1.898-1.865-3.437-4.167-3.437zm-4.013 2.75c.344-.799 1.26-1.375 2.347-1.375h1.666c1.088 0 2.003.576 2.347 1.375h-6.36zM18 15.5c1.38 0 2.5-.923 2.5-2.063v-1.374C20.5 10.922 19.38 10 18 10s-2.5.923-2.5 2.063v1.374c0 1.14 1.12 2.063 2.5 2.063zm-.833-3.438c0-.38.372-.687.833-.687.46 0 .833.307.833.688v1.374c0 .38-.372.688-.833.688-.46 0-.833-.307-.833-.688v-1.374z"
}));

var SvgUsersList = function SvgUsersList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUsersList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/users-list.7ee47578.svg";
export { ForwardRef as ReactComponent };